import TextMetrics from './text-metrics';

export default function measureText(text, style, measureBox) {
    return TextMetrics.current.measure(text, style, measureBox);
}



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-drawing/dist/es/text-metrics/measure-text.js
// module id = ../../../../@progress/kendo-drawing/dist/es/text-metrics/measure-text.js
// module chunks = vendor